import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import * as CryptoJS from 'crypto-js';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { Variables } from 'src/app/Models/variables';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
  selector: 'app-process-compliance-ranking',
  templateUrl: './process-compliance-ranking.component.html',
  styleUrls: ['./process-compliance-ranking.component.css']
})
export class ProcessComplianceRankingComponent implements OnInit {

  data: any;
  range: any;
  start: any;
  end: any;
  show = false;
  load = false;
  options: { title: { display: boolean; text: any; fontSize: number; }; legend: { position: string; }; };

  allcount = 0;
  isadm = false;
  configs1 = [];

  constructor(
    private analytics: AnalyticsService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private notificationSvc: NotificationService,
    private reportService: ReportsService,
    private configService: ConfigurationService
  ) {
      this.translate.addLangs(['English', 'French']);
      this.translate.setDefaultLang('English');

      let browserLang = this.translate.getBrowserLang();

      const pass = 'ranitessarldev2019';
      const lang = cookieService.get('goepla-portal-language');
      if (lang.trim() !== '') {
        const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
        const lg = declang;
        browserLang = lg;
        localStorage.setItem('language', lg);
      }

      if (localStorage.getItem('language') !== null) {
        browserLang = localStorage.getItem('language');
      }
      this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

      if (localStorage.getItem('filter-start') !== null && localStorage.getItem('filter-end') !== null) {
        const st = localStorage.getItem('filter-start');
        const ed = localStorage.getItem('filter-end');
        this.range = [new Date(st), new Date(ed)];
      }

      const v = new Variables();
      const p = localStorage.getItem('ups');
      if (p == null) {
        this.isadm = false;
      }

      const pr = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
      const perm = JSON.parse(pr);
      if (perm.includes('NTM.Administration.Full')) {
            this.isadm = true;
      }
   }

   ok() {
    this.data = [];
    if (this.range === undefined || this.range === null) {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
        this.confirm(res);
      });
      return;
    } else {
      if (this.range[0] !== undefined && this.range[0] !== null) {
        this.start = this.range[0].toDateString();
        const a = this.range[0].toDateString();
        const b = new Date(a);
        const c = new Date(b.getFullYear(), b.getMonth(), b.getDate());
        this.start = c.toDateString();
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
          this.confirm(res);
        });
        return;
      }
      if (this.range[1] !== undefined && this.range[1] !== null) {
        this.end = this.range[1].toDateString();
        const a = this.range[1].toDateString();
        const b = new Date(a);
        const c = new Date(b.getFullYear(), b.getMonth(), b.getDate());
        this.end = c.toDateString();
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
          this.confirm(res);
        });
        return;
      }
      localStorage.setItem('filter-start', this.start);
      localStorage.setItem('filter-end', this.end);
      this.getAnalytics();
    }
   }

  ngOnInit() {
  }

  async getConfigurations() {
    this.load = true;
    // tslint:disable-next-line: deprecation
    const res = await this.configService.getConfigurations('T').toPromise();
    if (res != null) {
      const v = new Variables();
      const gis = localStorage.getItem('gi');
      const gs = CryptoJS.AES.decrypt(gis, v.pass).toString(CryptoJS.enc.Utf8);
      const gids = JSON.parse(gs);

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < res.length; i++) {
        if (res[i].typeRoleGroups !== null && res[i].typeRoleGroups.length > 0) {
          let show = false;
          for (const val of res[i].typeRoleGroups) {
            if (val.typeRoleGroup.roleName === 'Analytics' && gids.includes(val.typeRoleGroup.groupId)) {
              show = true;
            }
          }

          if (this.isadm === true) {
            show = true;
          }

          if (show === false) {
            continue;
          }
        } else {
          if (this.isadm === true) {
          } else {
            continue;
          }
        }
        this.configs1.push({ label: res[i].configurationName, value: res[i] });
      }
    }
  }

  async getAnalytics() {
    await this.getConfigurations();
    if (this.configs1 === undefined || this.configs1 === null || this.configs1.length === 0) {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.NODATAAVAILABLE').subscribe((resp: string) => {
        this.notificationSvc.info('', resp, 2000);
        });
      this.load = false;
      return;
    }
    let tids = '';
    if (this.allcount + 1 !== this.configs1.length) {
      for (const val of this.configs1) {
        if (val.value.configurationId !== 0) {
          tids += val.value.configurationId + ',';
        }
      }
    }
    if (tids === '') {
      tids = ' ';
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.NODATAAVAILABLE').subscribe((resp: string) => {
        this.notificationSvc.info('', resp, 2000);
        });
      this.load = false;
      return;
    }
    this.show = false;
    this.load = true;

    let perc = '';
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.PERCENTAGE').subscribe((trans) => {
      perc = trans;
    });

    const report1 = await this.reportService.getReportGeneric(0, this.start, this.end, 'PROCESSCOMPLIANCERANKING', tids).toPromise()
    .catch(err => this.handleError(err));

    if (report1 != null && report1.length > 0) {
      // report1.sort((a, b) => +a.value3.localeCompare(+b.value3));
      report1.sort((a, b) => +a.value3 - +b.value3);
      const labs: string[] = [];
      const datasets: number[] = [];
      let count = 0;
      for (const val of report1) {
        labs.push(val.value1);
        datasets.push(Math.round((+val.value3 + Number.EPSILON) * 100) / 100);
        count += 1;
        if (count === report1.length) {
          this.data = {
            labels: labs.reverse(),
            datasets: [
                {
                    label: perc,
                    backgroundColor: '#42A5F5',
                    borderColor: '#1E88E5',
                    data: datasets.reverse()
                }
            ]
          };
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.PROCESSCOMPLIANCERANKING').subscribe((trans) => {
            this.options = {
              title: {
                  display: true,
                  text: trans,
                  fontSize: 16
              },
              legend: {
                  position: 'top'
              }
            };
          });
        }
      }
      this.show = true;
    } else {
      this.show = false;
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.NODATAAVAILABLE').subscribe((resp: string) => {
        this.notificationSvc.info('', resp, 2000);
      });
    }

    this.load = false;
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
  }

  showInfo() {
    this.messageService.add({severity: 'info', summary: 'Info Message', detail: 'PrimeNG rocks'});
  }

  handleError(err) {
    this.load = false;
    console.log(err);
  }

  setDate() {
    const d = new Date();
    const d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
    const d2 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);

    this.range = [d1, d2];
  }

}
